import { Component, signal, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { CommonModule } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { RouterModule } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-login',
  standalone: true,
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
  imports: [
    ReactiveFormsModule,
    FormsModule,
    CommonModule,
    MatButtonModule,
    MatInputModule,
    MatCardModule,
    MatCheckboxModule,
    RouterModule
  ]
})
export class LoginComponent implements OnInit {
  login = {
    username: '',
    password: ''
  };

  centralLoginUrl: string = ''; // <-- VariÃ¡vel que vai armazenar a URL completa de login via Central de Acessos

  constructor(
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute, // <-- NecessÃ¡rio para capturar parÃ¢metros da URL
    private toastService: ToastrService,
    private http: HttpClient
  ) {}

  ngOnInit(): void {
    // <-- Monta a URL de login da Central de Acessos usando as variÃ¡veis de ambiente
    this.centralLoginUrl = `${environment.centralAuthUrl}?client_id=${environment.centralClientId}&response_type=code&redirect_uri=${encodeURIComponent(environment.centralRedirectUri)}`;

    // <-- Verifica se existe um cÃ³digo na URL de retorno da Central
    this.route.queryParams.subscribe(params => {
      const code = params['code'];
      if (code) {
        this.exchangeCodeForToken(code); // <-- Envia o cÃ³digo para a API e recebe o token
      }
    });
  }

  onSubmit() {
    this.authService.login(this.login.username, this.login.password).subscribe({
      next: () => {
        this.toastService.success("Login feito com sucesso!");
        this.router.navigate(['/ava-unesp']);
      },
      error: () => this.toastService.error("UsuÃ¡rio ou Senha invÃ¡lidos")
    });
  }

  // <-- MÃ©todo que envia o `code` recebido da Central e troca por token via API
  exchangeCodeForToken(code: string): void {
    const body = {
      code,
      redirect_uri: environment.centralRedirectUri // <-- Deve bater com o usado na URL da Central
    };

    this.http.post<any>(`${environment.apiUrl}/auth/login/oauth2/code/central`, body).subscribe({
      next: (res) => {
        sessionStorage.setItem('token', res.token); // <-- Armazena o token retornado pela API
        sessionStorage.setItem('loginOrigin', 'central');
        this.toastService.success("Login via Central realizado com sucesso!");
        this.router.navigate(['/']); // <-- Redireciona para pÃ¡gina principal
      },
      error: (err) => {
        this.toastService.error("Erro no login via Central de Acessos.");
      }
    });
  }
}
